export function sanitizeSlugInput(slug) {
  if (slug) {
    return slug.toLowerCase().trim().replace(/(\s+)|(-+)/g, '-');
  }
  return slug;
}